var _defs, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6969",
    "data-name": "Group 6969",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.593,
    height: 14.723,
    viewBox: "0 0 22.593 14.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1264",
    "data-name": "Rectangle 1264",
    width: 22.593,
    height: 14.723,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7606",
    "data-name": "Path 7606",
    d: "M13.517,0,10.073,4.254l2.634,5.47,4.356-3.241Z",
    transform: "translate(5.53 0)",
    fill: "#2e117f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4728",
    "data-name": "Group 4728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7607",
    "data-name": "Path 7607",
    d: "M16.02,9.263C15.007,8.656,13.083,4,13.083,4L10.2,4.654,8.456,2.913a4.56,4.56,0,0,0-6.448,0L12.951,13.856l3.224-3.222a.8.8,0,0,0-.155-1.371",
    transform: "translate(1.103 0.866)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1263",
    "data-name": "Rectangle 1263",
    width: 2.532,
    height: 9.749,
    transform: "translate(0 6.47) rotate(-45)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7608",
    "data-name": "Path 7608",
    d: "M1.059,9.73h0a.58.58,0,0,1,0-.819L3.367,6.6a.579.579,0,1,1,.819.819L1.879,9.73a.58.58,0,0,1-.819,0",
    transform: "translate(0.488 3.532)",
    fill: "#2e117f"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrake);
export default __webpack_public_path__ + "static/media/brake.2d17774f528c4802f9fb718d289d83d3.svg";
export { ForwardRef as ReactComponent };